<ion-header>
  <ion-toolbar>
    <ion-title *ngIf="dataServ.rData">{{dataServ.rData.name}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content #content>
  <ion-grid *ngIf="dataServ.rData">

    <ng-container *ngFor="let msg of messages">

      <ion-row class="gallery" *ngIf="msg.gallery">
        <ion-col size="9" *ngFor="let img of msg.gallery; let i = index">
          <ion-img [src]="img" (click)="images = msg.gallery; fullPageSlider.initialSlide = i; fullImage = true">
          </ion-img>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="10" [offset]="msg.user === 'hotel' ? 0 : 2">
          <div [class]="msg.user === 'hotel' ? 'bubble' : 'bubble reply'">

            <ion-row>
              <ion-col size="3" *ngIf="msg.user === 'hotel'">
                <ion-avatar>
                  <img [src]="msg.avatar || dataServ.rData.dark_logo[0]" />
                </ion-avatar>
              </ion-col>

              <ion-col size="9">
                <b>{{(msg.user === 'hotel' ? (msg.nick || dataServ.rData.name) : 'Guest') | caption | translate}}</b>
                <br>

                <ng-container [ngSwitch]="msg.type">
                  <ng-container *ngSwitchCase="'text'">
                    <span [innerHtml]="msg.msg | caption | translate"></span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'schedule'">
                    <a (click)="modalServ.schedule(msg.item)">
                      {{'See Full Schedule' | caption | translate}}</a>
                  </ng-container>

                  <ng-container *ngSwitchCase="'reservation'">
                    <a (click)="reservation(msg)">
                      {{'Reservation' | caption | translate}}</a>
                  </ng-container>
                </ng-container>
              </ion-col>

              <ion-col size="3" *ngIf="msg.user !== 'hotel'">
                <ion-avatar>
                  <img src="https://anitar.dev/get/r?rand=2" />
                </ion-avatar>
              </ion-col>
            </ion-row>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="cards" *ngIf="msg.data && msg.data.length > 0">
        <ng-container *ngFor="let section of msg.data">
          <ng-container *ngIf="section.menu_categories && section.menu_categories.length > 0">
            <ng-container *ngFor="let cat of section.menu_categories">
              <ng-container *ngIf="cat.menu_items && cat.menu_items.length > 0">
                <ng-container *ngFor="let item of cat.menu_items">
                  <ion-col size="10">
                    <ion-card (click)="detail(item, section, cat)">
                      <img [src]="item.image_url" *ngIf="item.image_url" alt="Image">

                      <ion-card-header>
                        <ion-card-title>{{item.name | caption | translate}}</ion-card-title>
                      </ion-card-header>
                    </ion-card>
                  </ion-col>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ion-row>

    </ng-container>

  </ion-grid>
</ion-content>

<ion-footer>
  <ion-buttons>
    <ng-container *ngFor="let btn of buttons">
      <ion-button color="dark" (click)="write(btn)">

        <ion-grid class="ion-no-padding">
          <ion-row class="ion-no-padding">
            <ion-col size="12">
              <ion-icon [name]="btn.icon"></ion-icon>
            </ion-col>
          </ion-row>

          <ion-row class="ion-no-padding">
            <ion-col size="12">
              {{btn.name | translate}}
            </ion-col>
          </ion-row>
        </ion-grid>

      </ion-button>
    </ng-container>
  </ion-buttons>
</ion-footer>

<div class="full-img" *ngIf="fullImage">
  <div class="bg-overlay" (click)="fullImage = false"></div>
  <ion-icon name="close" color="white" (click)="fullImage = false"></ion-icon>
  <ion-slides mode="ios" pager="ios" zoom [options]="fullPageSlider">
    <ion-slide *ngFor="let img of images">
      <img [src]="img">
    </ion-slide>
  </ion-slides>
</div>